import { SkeletonDesignTokens } from '@primeng/themes/types/skeleton';

export const baseSkeletonToken: SkeletonDesignTokens = {
  colorScheme: {
    light: {
      root: {
        background: '{gray.50}',
      },
    },
  },
};
